import { isBloggerBusiness } from '../../../../../utils/accessService';
import { buildImageSource, buildImageSourceSet } from '../../../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../../../utils/getDomainFromUrl/getDomainFromUrl';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconProduct } from '../../../../icon/IconProduct';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { Image } from '../../../../media/Image';
import { MediaCover } from '../../../../media/MediaCover';
import { Typography } from '../../../../typography/Typography';
import { ProductUnavailableLabel } from '../../../ProductUnavailableLabel/ProductUnavailableLabel';
import { Card, Title } from '../../styles';
import type { UnavailableProductCardProps } from './types';

export const UnavailableProductCard = ({ product, business }: UnavailableProductCardProps) => {
    const t = useTranslation();
    const { content, title } = product;

    const media = content[0]?.media;

    const isBlogger = isBloggerBusiness(business?.type);
    const domain = isBlogger ? getDomainFromUrl(product.originalUrl) : undefined;

    return (
        <Card>
            <MediaCover
                ratio={1}
                overflow="hidden"
                borderRadius="20px"
                backgroundColor="var(--background-primary)"
            >
                <Flex alignItems="center" justifyContent="center">
                    {media ? (
                        <Image
                            objectFit="contain"
                            width="100%"
                            height="100%"
                            src={buildImageSource(media)}
                            srcSet={buildImageSourceSet(media)}
                            style={{ opacity: 0.5 }}
                        />
                    ) : (
                        <IconProduct size={72} color="var(--control-secondary-background)" />
                    )}
                </Flex>
            </MediaCover>
            <Box p={1} pb={0.5}>
                <Title variant="body2" weight="regular" color="secondary">
                    {t(title)}
                </Title>
            </Box>
            <ProductUnavailableLabel
                px={1}
                pb={domain ? 0 : 1}
                color={isBlogger ? 'error' : 'secondary'}
            />
            {domain ? (
                <Typography variant="caption" color="var(--color-secondary)" px={1} pt={0.5} pb={1}>
                    {domain}
                </Typography>
            ) : null}
        </Card>
    );
};
